export const AnalyticsEvents = {
  // Conversion Funnel
  SIGNUP_STARTED: 'signup_started',
  ACCOUNT_CREATED: 'account_created',
  KYC_STARTED: 'kyc_started',
  KYC_COMPLETED: 'kyc_completed',
  DEPOSIT_STARTED: 'deposit_started',
  DEPOSIT_COMPLETED: 'deposit_completed',
  CARD_ACTIVATION_STARTED: 'card_activation_started',
  CARD_ACTIVATION_COMPLETED: 'card_activation_completed',
  CARD_FIRST_TX_COMPLETED: 'card_first_tx_completed',
  SAVINGS_STARTED: 'savings_started',
  SAVINGS_OPENED: 'savings_opened',

  // Core Money Flows
  MONEY_ACTION_STARTED: 'money_action_started',
  MONEY_ACTION_COMPLETED: 'money_action_completed',

  // Core Engagement
  SCREEN_VIEWED: 'screen_viewed',
  HOME_CTA_CLICKED: 'home_cta_clicked',
  ACTION_USED: 'action_used',

  // Error / Drop-off
  KYC_ERROR: 'kyc_error',
  DEPOSIT_FAILED: 'deposit_failed',

  // Esim
  // Esim
  ESIM_STARTED: 'esim_started',
  ESIM_COMPLETED: 'esim_completed',

  // Crypto
  CRYPTO_ACTION_STARTED: 'crypto_action_started',
  CRYPTO_ACTION_COMPLETED: 'crypto_action_completed',
} as const
